module.exports = __webpack_public_path__ + "static/img/icon-safe7.8254335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-safe7.png
// module id = O/om
// module chunks = 21